import { render } from "./PatientSummary.vue?vue&type=template&id=87042968&scoped=true&ts=true"
import script from "./PatientSummary.vue?vue&type=script&lang=ts"
export * from "./PatientSummary.vue?vue&type=script&lang=ts"

import "./PatientSummary.vue?vue&type=style&index=0&id=87042968&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87042968"]])

export default __exports__